// removed by extract-text-webpack-plugin
module.exports = {"InfoTextContent":"_2ILO1bplBZ9D3_HORz2Ksw","InfoTextFinal":"_1pje_3pTL0zEYOpTpT9-8s"};


//////////////////
// WEBPACK FOOTER
// ./src/ConnectedComponents/Setup/SyncInfo/index.css
// module id = 1452
// module chunks = 1